import { useCallback, useEffect, useRef } from 'react';
import {
    datakatalogTabChannelName,
    isDatakatalogTabMessage,
    type DatakatalogTabMessage,
} from './standaloneChannel';

export const useDatakatalogTabMessages = (
    token: string | null,
    onMessage: (message: DatakatalogTabMessage) => void
) => {
    const onMessageRef = useRef(onMessage);
    const channelRef = useRef<BroadcastChannel | null>(null);

    useEffect(() => {
        onMessageRef.current = onMessage;
    }, [onMessage]);

    useEffect(() => {
        if (!token) return;

        const channel = new BroadcastChannel(datakatalogTabChannelName(token));
        channelRef.current = channel;
        channel.onmessage = event => {
            if (isDatakatalogTabMessage(event.data)) {
                onMessageRef.current(event.data);
            } else {
                console.warn('Ugyldig melding fra Datakatalog-fanen', event.data);
            }
        };
        const disconnect = () => channel.postMessage({ type: 'DISCONNECT' });
        window.addEventListener('beforeunload', disconnect);

        return () => {
            window.removeEventListener('beforeunload', disconnect);
            disconnect();
            channel.close();
            if (channelRef.current === channel) channelRef.current = null;
        };
    }, [token]);

    return useCallback((message: DatakatalogTabMessage) => {
        if (!channelRef.current) {
            console.warn('Ingen forbindelse til Datakatalog-fanen');
            return;
        }
        channelRef.current.postMessage(message);
    }, []);
};
